
import { 
    Container,
    Row,
    Col
} from "react-bootstrap";

function ExternalPDFPage5(props: any) {

    let backGroundColor = (color:any) =>{
        switch (color) {
            case 'green':
                return '#7fffb6';
            case 'yellow':
                return '#ffff00';
            default:
                return '#7fffb6';
        }
    }

    return (
        <>
            <Container fluid className="text-left page-break cu-pt-10" style={{margin: "190px 0 0 0px", paddingBottom: "200px"}}>
                <h3 className="cu-fs-18">{props.TranslateString("Analyysin yhteenveto")} ​</h3>
                <Row className="mx-lg-5">
                    <Col sm={8}>
                        <table className="table table-borderless cu-fs-16 mb-0">
                            <tbody>
                                <tr>
                                    <th className="cu-bg-green2 cu-text-lightgreen2 text-center cu-h-100 cu-border-radius-12 d-xy-center">
                                        {props.TranslateString("Loan to Value - indikaatio​")}
                                    </th>
                                    <td>&emsp;</td>
                                    <td className="text-dark cu-width-80p cu-border-radius-12" style={{background:backGroundColor(props?.ltvDetails?.loanData_total?.ltv_summary_color)}}>
                                    <ul>
                                       <li>{props?.ltvDetails?.loanData_total?.ltv_summary_value || ""}</li>
                                    </ul>
                                    </td>
                                </tr>
                                <tr><td colSpan={3}></td></tr>
                                <tr>
                                    <th className="cu-bg-green2 cu-text-lightgreen2 text-center cu-h-100 cu-border-radius-12 d-xy-center">
                                        {props.TranslateString("Osakkaat")}
                                    </th>
                                    <td>&emsp;</td>
                                    <td className="text-dark cu-width-80p cu-border-radius-12" style={{background:backGroundColor(props?.data?.shareholder_color)}}>
                                        <ul>
                                            {
                                                props?.data?.shareholder_summary?.map((element:any)=>{
                                                    return (<li key={Math.random()}>{element}​</li>);
                                                })
                                            }
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Col>
                    <Col className="d-flex align-items-center justify-content-center cu-fs-16">
                        <div>
                            <div className="d-flex align-items-center">
                                <div className="cu-box-height-30px cu-bg-lightgreen2 cu-border-radius-12">&emsp;</div>
                                <div>&emsp;{props.TranslateString("Ei huomioitavaa")}​</div>
                            </div>
                            &nbsp;
                            <div className="d-flex align-items-center">
                                <div className="cu-box-height-30px cu-bg-yellow cu-border-radius-12">&emsp;</div>
                                <div>&emsp;{props.TranslateString("Huomioitavaa​")}</div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default ExternalPDFPage5;